import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isUserTicketLoading = (state: TRootState): boolean =>
  arrayContains(state.organizer.openRequests, [
    Actions.findUserTicketRequest.type,
    Actions.findUserTicketsRequest.type,
  ]);
